<template>
  <div class="tabs-bar">
    <div class="tabs-scroll">
      <div
        class="tab"
        :class="{ on: abaAtiva === 'inicio' }"
        @click="ativar('inicio')"
      >
        <i class="bi bi-house-door tico"></i>
        <span>{{ $t('inicio') }}</span>
      </div>

      <div
        class="tab"
        v-for="(aba, index) in tabs"
        :key="aba.lk_link"
        :class="{ on: abaAtiva === aba.lk_link, arrastando: indiceArrastado === index, 'sobre-alvo': indiceSobreAlvo === index }"
        :title="aba.ds_link"
        draggable="true"
        @click="ativar(aba.lk_link)"
        @dragstart="aoIniciarArraste(index)"
        @dragover.prevent="aoPassarSobre(index)"
        @drop.prevent="aoSoltar(index)"
        @dragend="aoTerminarArraste"
      >
        <i :class="'bi ' + (aba.ic_link || 'bi-bar-chart') + ' tico'"></i>
        <span>{{ aba.ds_link }}</span>
        <i class="bi bi-arrow-clockwise recarregar" :title="$t('recarregar_relatorio')" @click.stop="recarregar(aba.lk_link)"></i>
        <i class="bi bi-x fechar" :title="$t('fechar_aba')" @click.stop="fechar(aba.lk_link)"></i>
      </div>

      <button class="tab-add" :title="$t('buscar_abrir_relatorio')" @click="abrirBusca">
        <i class="bi bi-plus-lg"></i>
      </button>
    </div>

    <button v-if="temTutorial" class="tab-tutorial" :title="$t('tutorial_desta_tela')" @click="abrirTutorial">
      <i class="bi bi-mortarboard"></i>
      <span>{{ $t('tutorial_desta_tela') }}</span>
    </button>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'TabsBar',
  data() {
    return {
      indiceArrastado: null,
      indiceSobreAlvo: null
    }
  },
  computed: {
    tabs() {
      return this.$store.getters['abas/tabs']
    },
    abaAtiva() {
      return this.$store.getters['abas/abaAtiva']
    },
    dsLinkAtivo() {
      if (this.abaAtiva === 'inicio') return this.$t('inicio')
      const aba = this.tabs.find(t => t.lk_link === this.abaAtiva)
      return aba ? aba.ds_link : this.abaAtiva
    },
    temTutorial() {
      if (this.abaAtiva === 'inicio') return false
      const aba = this.tabs.find(t => t.lk_link === this.abaAtiva)
      return !!(aba && Number(aba.tem_tutorial))
    }
  },
  methods: {
    abrirTutorial() {
      this.$store.dispatch('tutorial/abrir', { lkLink: this.abaAtiva, dsLink: this.dsLinkAtivo })
    },
    ativar(id) {
      this.$store.dispatch('abas/ativarAba', id)
    },
    fechar(lkLink) {
      this.$store.dispatch('abas/fecharAba', lkLink)
    },
    recarregar(lkLink) {
      this.$store.dispatch('abas/recarregarAba', lkLink)
    },
    abrirBusca() {
      this.$store.dispatch('ui/abrirComando')
    },
    aoIniciarArraste(index) {
      this.indiceArrastado = index
    },
    aoPassarSobre(index) {
      if (this.indiceArrastado === null) return
      this.indiceSobreAlvo = index
    },
    aoSoltar(index) {
      if (this.indiceArrastado === null || this.indiceArrastado === index) {
        this.aoTerminarArraste()
        return
      }

      const novasTabs = [...this.tabs]
      const [movida] = novasTabs.splice(this.indiceArrastado, 1)
      novasTabs.splice(index, 0, movida)

      this.$store.dispatch('abas/reordenarAbas', novasTabs)
      this.aoTerminarArraste()
    },
    aoTerminarArraste() {
      this.indiceArrastado = null
      this.indiceSobreAlvo = null
    }
  }
}
</script>

<style scoped>
.tabs-bar {
  padding-left: 50px!important;
  display: flex;
  align-items: center;
  gap: 8px;
  background: var(--rd-bg-app);
  padding: 8px 8px 0;
}

.tabs-scroll {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 2px;
  min-width: 0;
  overflow-x: auto;
}

.tab {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 10px;
  border-radius: 8px 8px 0 0;
  color: var(--rd-text-2);
  max-width: 200px;
  cursor: pointer;
  white-space: nowrap;
}

.tab span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
}

.tab .tico {
  font-size: 14px;
}

.tab.on {
  background: var(--rd-bg-2);
  color: var(--rd-text-1);
}

.tab.arrastando {
  opacity: 0.4;
}

.tab.sobre-alvo {
  box-shadow: inset 2px 0 0 var(--rd-accent);
}

.tab .recarregar,
.tab .fechar {
  font-size: 14px;
  color: var(--rd-text-3);
  border-radius: 4px;
  padding: 1px;
}

.tab .recarregar:hover,
.tab .fechar:hover {
  background: var(--rd-hover);
  color: var(--rd-text-1);
}

.tab-add {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 8px;
  color: var(--rd-text-3);
  background: none;
  border: none;
  margin-left: 4px;
  cursor: pointer;
}

.tab-add:hover {
  background: var(--rd-hover);
  color: var(--rd-text-1);
}

.tab-tutorial {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
  padding: 0 12px;
  height: 30px;
  border-radius: 999px;
  border: 1px solid var(--rd-border-strong);
  background: var(--rd-bg-1);
  color: var(--rd-text-1);
  font-weight: 500;
  font-size: 12px;
  white-space: nowrap;
  cursor: pointer;
}

.tab-tutorial i {
  font-size: 14px;
}

.tab-tutorial:hover {
  background: var(--rd-hover);
  color: var(--rd-text-1);
}
</style>
